import { ActivityFragment } from "../../../../../../../../__generated__/graphql";
import Avatar from "../../../../../../../../components/Avatar";

export default function ParticipantsComponents({
  activity,
}: {
  activity: ActivityFragment;
}) {
  if (!activity.activityParticipants) {
    return null;
  }

  const MAX_DISPLAYED = 2;
  const participants = activity.activityParticipants;
  const remainingCount = participants.length - MAX_DISPLAYED;

  return (
    <div className="flex -space-x-2 items-center">
      {participants.slice(0, MAX_DISPLAYED).map((participant) => (
        <Avatar
          key={participant.id}
          size="small"
          userOrganization={participant.publicUserOrganization}
        />
      ))}
      {remainingCount > 0 && (
        <div className="flex items-center justify-center w-6 h-6 rounded-full text-sm bg-accent text-dark">
          <div className="text-xs font-bold">+{remainingCount}</div>
        </div>
      )}
    </div>
  );
}
